<template>
  <div v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.LIST)" class="spl-parcel-detail-block-documents">
    <div class="spl-parcel-detail-block-documents__label">
      {{ label }}
    </div>
    <!-- *********************** Edit Button *********************************** -->
    <div
      v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPDATE)"
      :class="{'spl-parcel-detail-block-scans__edit-open': isEditing}"
      class="spl-parcel-detail-block-scans__edit"
      @click="toggleEditable" />

    <!-- *********************** Rows for docuemnts in view mode *********************************** -->
    <div
      v-if="!isEditing"
      class="spl-parcel-detail-block-documents__body-table"
      data-cy="spl-parcel-detail-block-documents__body-table">
      <div class="spl-parcel-detail-block-documents__body__header">
        <div class="spl-parcel-detail-block-documents__body__header__checkbox">
          <form-checkbox
            :has-margin="true"
            :checked="allSelected"
            @checkboxChanged="masterCheckboxChanged" />
        </div>
        <div class="spl-parcel-detail-block-documents__body__header__column">
          File
        </div>
      </div>
      <div
        v-for="(item, index) in blockContent"
        :key="'parcelDetailDocumentsBlockContent' + index"
        class="spl-parcel-detail-block-documents__body__row">
        <div class="spl-parcel-detail-block-documents__body__row__checkbox">
          <form-checkbox
            :has-margin="true"
            :checked="item.selected"
            @checkboxChanged="checkboxChanged(index)" />
        </div>
        <div
          class="spl-parcel-detail-block-documents__body__row__column spl-parcel-detail-block-documents__function-button"
          @click="downloadDocument(item.documentID, item.filename)">
          {{ item.description + " (" + item.filename + ")" }}
        </div>
      </div>
    </div>
    <!-- *********************** Rows for the docuemtns in edit mode *********************************** -->
    <div v-if="isEditing" class="spl-parcel-detail-block-documents__body">
      <div v-for="(item, index) in blockContent" :key="'parcelDetailDocumentsEdit' + index">
        <form-label>Description</form-label>
        <form-input
          :value="item.description"
          :index="index"
          @updateInputValue="updateItemValue" />
      </div>
    </div>

    <div v-if="isEditing" class="row">
      <div class="col6">
        <form-button
          wide="true"
          secondary="true"
          @onClick="close">
          Cancel
        </form-button>
      </div>
      <div class="col6">
        In the future you will be able to save your changes.
        <!-- Hidden_Feature
                <form-button wide="true" :buttonCallback="save">Save</form-button>
              -->
      </div>
    </div>
    <!-- *********************** Upload function *********************************** -->
    <div v-if="!isEditing">
      <div
        v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.DELETE)"
        class="spl-parcel-detail-block-documents__function-button"
        @click="deleteDocument">
        Delete Document
      </div>
      <div
        v-if="userHasPermission(constants.PERMISSION_TYPES.DOCUMENT, constants.PERMISSION_VALUES.UPLOAD)"
        class="spl-parcel-detail-block-documents__function-button"
        @click="uploadDocument">
        Upload Document
      </div>
    </div>
  </div>
</template>

<script>
import Helpers from '@/helpers'
import constants from '@/constants'
export default {
  name: 'ParcelDetailBlockDocuments',
  mixins: [Helpers],
  props: [
    'label',
    'content',
    'parcelKey'
  ],
  data () {
    return {
      tempBlockContent: this.cloneArray(this.content || []),
      isEditing: false,
      constants
    }
  },
  computed: {
    blockContent () {
      return this.content
    },
    allSelected () {
      return this.blockContent.length > 0 && this.blockContent.length === this.blockContent.filter((item) => { return item.selected }).length
    }
  },

  methods: {
    close () {
      this.isEditing = false
    },
    save () {
      this.blockContent = this.cloneArray(this.tempBlockContent)
      this.close()
    },
    toggleEditable () {
      this.isEditing = !this.isEditing
    },
    updateItemValue (inputValue, index) {
      if (inputValue.label) inputValue = inputValue.label
      this.tempBlockContent[index].description = inputValue
    },
    deleteDocument () {
      const count = this.blockContent.filter((item) => { return item.selected }).length
      if (count === 0) return

      if (window.confirm('Are you sure you want to delete ' + (count === 1 ? 'this item' : 'these items') + '?')) {
        const indices = []
        this.blockContent.forEach((item, index) => {
          if (item.selected) indices.push(index)
        })
        for (var i = indices.length - 1; i >= 0; i--) {
          this.blockContent.splice(indices[i], 1)
        }
      }
    },
    uploadDocument () {
      window.bus.$emit('openFileUploadModal', [this.parcelKey])
    },
    downloadDocument (itemID, fileName) {
      this.getDownload(this, itemID, fileName)
    },
    masterCheckboxChanged () {
      const allSelected = this.allSelected
      this.blockContent.forEach((item) => { item.selected = !allSelected })
    },
    checkboxChanged (index) {
      this.blockContent[index].selected = !this.blockContent[index].selected
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';

    .spl-parcel-detail-block-documents {
        background-color: $parcelTimelineBackgroundColor;
        margin-bottom: 20px;
        padding: 20px 17px 30px 17px;
        position: relative;
        width: 100%;

        &__edit {
            background-image: url(../../assets/icon-tripple-dot.svg);
            background-position: center center;
            background-repeat: no-repeat;
            cursor: pointer;
            height: 25px;
            position: absolute;
            right: 10px;
            top: 20px;
            transition: opacity $shortTransition ease-in-out;
            width: 25px;

            &:hover {
                opacity: 0.5;
            }
            &-open {
                background-image: url(../../assets/icon-close.svg);
            }
        }
        &__label {
            color: $mainInputColor;
            font-size: 18px;
            font-weight: 600;
            margin-bottom: 15px;
        }
        &__body {
            &-table {
                margin: 20px -17px 0 -17px;
            }
            &__header,
            &__row {
                &:after {
                    clear: both;
                    content: '';
                    display: block;
                    float: none;
                }
                &__checkbox {
                    float: left;
                    padding-left: 17px;
                    width: 10%;
                }
                &__column {
                    font-size: 12px;
                    float: left;
                    line-height: 26px;
                    padding-left: 10px;
                }
            }
            &__header {
                &__column {
                    font-size: 14px;
                    font-weight: 600;
                }
            }
            &__row-red {
                color: $red;
            }
            &__row:nth-child(even) {
                background-color: $parcelDetailBlockLogRowColor;
            }
        }

        .spl-button {
            margin-bottom: 0;
        }
        &__function-button {
            color: $middleYellow;
            cursor: pointer;
            font-size: 12px;
            font-weight: 600;
            transition: color $shortTransition ease-in-out;

            &:hover {
                color: $mainInputColor;
            }
            input[type="file"] {
                display: none;
            }
        }
        &__highlight {
            background-color: $parcelDetailBlockLogRowColor;
            border-left: 2px solid $parcelDetailBlockGreyHighlightColor;
            bottom: 0;
            color: $mainInputColor;
            font-size: 12px;
            font-weight: 400;
            margin: 15px -17px -30px -17px;
            padding: 15px;
        }
    }
</style>
